import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import ActionWithSymbol from '../actionWithSymbol/actionWithSymbol';
import { Calendar } from '../../icons';
import dateUtil from '../../util/date';
import DatePicker from '../datePicker/datePicker';
import ContextMenu from '../contextMenu/contextMenu';
import { dateTimeFormat, supportedWixlocales } from 'wix-design-systems-locale-utils';
var DatePickerInput = /*#__PURE__*/function (_React$Component) {
  function DatePickerInput(props) {
    var _this;
    _classCallCheck(this, DatePickerInput);
    _this = _callSuper(this, DatePickerInput, [props]);
    _this.getCustomButton = function () {
      var _this$props = _this.props,
        value = _this$props.value,
        translateIfNeeded = _this$props.translateIfNeeded,
        placeholder = _this$props.placeholder,
        removeIcon = _this$props.removeIcon,
        locale = _this$props.locale;
      var isValidDate = dateUtil.isValid(value);
      var children = isValidDate ? locale && dateTimeFormat.getShortDate(locale, value) || value.toLocaleDateString() : translateIfNeeded(placeholder);
      return /*#__PURE__*/React.createElement(ActionWithSymbol, {
        initialized: isValidDate,
        symbol: removeIcon ? false : /*#__PURE__*/React.createElement(Calendar, null)
      }, children);
    };
    return _this;
  }
  _inherits(DatePickerInput, _React$Component);
  return _createClass(DatePickerInput, [{
    key: "render",
    value: function render() {
      var shouldShowArrows = !this.props.stickToTop;
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.getClassName('control-date-picker-input'),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook
      }, /*#__PURE__*/React.createElement(ContextMenu, {
        className: "context-menu-block",
        alignment: "BOTTOM",
        direction: "MIDDLE",
        customButton: this.getCustomButton(),
        stickContentToTop: this.props.stickToTop,
        displayPopoverArrow: shouldShowArrows
      }, /*#__PURE__*/React.createElement(DatePicker, {
        value: this.props.value,
        onChange: this.props.onChange,
        validateDate: this.props.validateDate,
        showDelete: this.props.showDelete,
        todayLabel: this.props.todayLabel,
        goToSelectedLabel: this.props.goToSelectedLabel,
        startDay: this.props.startDay,
        days: this.props.days,
        monthNames: this.props.monthNames
      })));
    }
  }]);
}(React.Component);
DatePickerInput.displayName = 'DatePickerInput';
DatePickerInput.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  automationId: PropTypes.string,
  /** Placeholder to show when no date is selected */
  placeholder: PropTypes.string.isRequired,
  /** On date change callback */
  onChange: PropTypes.func.isRequired,
  /** Date value */
  value: PropTypes.object,
  /** */
  removeIcon: PropTypes.bool,
  /** A predicate function to decide what dates are accepted. */
  validateDate: PropTypes.func,
  /** sticks the calender to the top of the screen (used in Lean Component) */
  stickToTop: PropTypes.bool,
  /** see showDelete from DatePicker */
  showDelete: PropTypes.bool,
  /** locale that is used to determine date format */
  locale: PropTypes.oneOf(supportedWixlocales),
  todayLabel: DatePicker.propTypes.todayLabel,
  goToSelectedLabel: DatePicker.propTypes.goToSelectedLabel,
  startDay: DatePicker.propTypes.startDay,
  days: DatePicker.propTypes.days,
  monthNames: DatePicker.propTypes.monthNames
};
DatePickerInput.defaultProps = {
  removeIcon: false,
  stickToTop: false,
  showDelete: false
};
export default compose(DatePickerInput);